export default __webpack_public_path__ + "static/media/bottles.a47deaff.jpg";